export const planQueryKeys = {
  GET_PLANS: 'get_plans',
  ARCHIVE_URL: 'archive_url',
  INDICES: 'indices'
}

export const plansApiTypeOptions = {
  PROJECTS: 'projects',
  FOLDERS: 'folders'
}
